import { memoizeAsync } from '@suntex.core/utils';
import { Client } from '@suntex.fim/api-client';
import { AuthService } from '@suntex.fim/auth';
import { initAxiosAuth } from '@suntex.fim/framework';

export const init = memoizeAsync(
  async (config: {
    baseUrl: string;
    jwt: string;
  }): Promise<{ api: Client; auth: AuthService }> => {
    const { apiClient, authService } = initAxiosAuth(config.baseUrl);
    await authService.signIn({ jwt: config.jwt });
    return { api: apiClient, auth: authService };
  },
);
